import { render, staticRenderFns } from "./CanAddToCart.vue?vue&type=template&id=460c8198&"
import script from "./CanAddToCart.vue?vue&type=script&lang=js&"
export * from "./CanAddToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AddToCart: require('/vercel/path0/components/shop/AddToCart.vue').default,ArrowLeft: require('/vercel/path0/components/icons/ArrowLeft.vue').default})
